import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import {HotTableRegisterer} from "@handsontable/angular";
import Handsontable from "handsontable/base";
import {Observable, of, Subject} from "rxjs";
// import untersuchungsart from '../../assets/jsonFiles/untersuchungsart.json'
import {textRenderer} from "handsontable/renderers";
import {JsonArrayDownloaderService} from "../shared/services/json-array-downloader.service";
import {iInputMitVersteckterBox} from "../shared/entity/interfaces/allgemein";


@Component({
  selector: 'app-probenliste',
  templateUrl: './probenliste.component.html',
  styleUrls: ['./probenliste.component.scss']
})

export class ProbenlisteComponent implements AfterViewInit, OnInit {
  private hotRegisterer: HotTableRegisterer = new HotTableRegisterer();
  public probenlisteTabelleId: string = "probenListeTabelle";
  public hot: Handsontable | null = null;
  public untersuchungsArten?: string[];
  public tableSettings: any = {
    rowHeaders: true,
    colHeaders: true,
    startRows: 96,
    licenseKey: 'non-commercial-and-evaluation',
    height: "auto",
    width: "100%",
    contextMenu: {
      items: {
        'row_above': {},
        'row_below': {},
        'remove_row': {},
      }
    },
    columns: [
      {
        title: 'Probenbezeichnung',
        // placeholder: "Mindestens 5 Zeichen, nur Buchstaben und Zahlen",
        validator: /(^[A-Za-z0-9]{5,}$)|(^999999$)/,
        width: 150,
        renderer(instance: any, td: any, row: any, col: any, prop: any, value: any, cellProperties: any) {
          td.title = "Mindestens 5 Zeichen, nur Buchstaben und Zahlen";
          // @ts-ignore
          textRenderer.apply(this, arguments);
          return td;
        },
      },
      {
        title: 'Spezies',
        width: 150
        // validator: /^[a-zA-Z]+$/ // Allow only letters
      },
      {
        data: 'untersuchungsart',
        title: 'Untersuchungsart',
        type: 'autocomplete',
        strict: false,
        source: this.untersuchungsArten,
        trimDropdown: false,
        width: 300
      },
      {
        title: 'Barcode',
        width: 100,
      },
      {
        title: 'Referenzsequenz',
        width: 150,
      },
      {
        title: 'DNA-Konzentration(ng/µl)',
        validator: /[+-]?([0-9]*[.])?[0-9]+/,
        type: 'numeric',
        width: 200,
        renderer(instance: any, td: any, row: any, col: any, prop: any, value: any, cellProperties: any) {
          td.title = "Pflichtfeld, muss Zahlen enthalten";
          // @ts-ignore
          textRenderer.apply(this, arguments);
          return td;
        }
      },
    ],
  };

  constructor(private jsonArrayDownloader: JsonArrayDownloaderService, private cdr: ChangeDetectorRef) {
    this.jsonArrayDownloader.jsonArrayDownload("untersuchungsart").subscribe(
      daten => {
        this.untersuchungsArten = daten as string[];
        //super hässlich, funktioniert super gut.
        this.tableSettings.columns[2].source = this.untersuchungsArten;
        this.hot?.updateSettings(this.tableSettings);
        // cdr.detectChanges();
      }
    );
  }

  ngOnInit() {
    // this.jsonArrayDownloader.jsonArrayDownload("untersuchungsart").subscribe(
    //   daten => this.untersuchungsArten = daten as string[]
    // );
  }

  ngAfterViewInit() {

    this.hot = this.hotRegisterer.getInstance(this.probenlisteTabelleId);
    // @ts-ignore
    this.hot.addHook('beforeValidate', (_val, row) => {
      if (this.hot) {
        if (this.hot.isEmptyRow(row)) {
          const wertDerAlleValidatorenBesteht = 999999;
          return wertDerAlleValidatorenBesteht;
        }
      }
    });
    this.hot.addHook('afterCreateRow', (row: number, amount: number) => {
      if (this.hot) {
        for (let i = 0; i < this.hot.countRows(); i++) {
          this.hot.setCellMeta(
            i,
            this.hot.propToCol('untersuchungsart'),
            'source',
            this.untersuchungsArten,
          );
        }
      }
    })
    if (this.hot) {
      for (let i = 0; i < this.hot.countRows(); i++) {
        this.hot.setCellMeta(
          i,
          this.hot.propToCol('untersuchungsart'),
          'source',
          this.untersuchungsArten,
        );
      }
    }
  }

  public getValidationStatusObservable(): Observable<boolean> {
    let s: Subject<boolean> = new Subject<boolean>()
    if (this.hot) {
      if (this.hot.countRenderedRows() > 0) {
        this.hot.validateCells((isValid: boolean) => {
          s.next(isValid)
          s.complete()
        });
      } else {
        return of(true);
      }

    }
    return s.asObservable()
  }

  public getTabellenDaten() {
    if (this.hot) {
      if (this.hot.countRenderedRows() > 0) {
        return this.hot.getData();
      }
    }
    return []
  }

}
